import { UserType } from '@quipex/shared/contracts';

type FourStarters = readonly [string, string, string, string];

export const DOCUMENT_TOPICS = {
    [UserType.Homeowner]: [
        'appliance warranties',
        'home maintenance manuals',
        'renovation approvals',
        'inspection reports',
    ],
    [UserType.PropertyValuer]: [
        'valuation reports',
        'floor plans',
        'lease agreements',
        'condition reports',
    ],
    [UserType.Architect]: [
        'architectural drawings',
        'as-built plans',
        'planning approvals',
        'building specifications',
    ],
    [UserType.Lawyer]: [
        'statutory notices',
        'contracts',
        'lease agreements',
        'occupancy approvals',
    ],
    [UserType.Conveyancer]: [
        'title records',
        'occupancy permits',
        'planning approvals',
        'owners corporation records',
    ],
    [UserType.Insurer]: [
        'insurance policies',
        'risk assessments',
        'fire safety reports',
        'claims records',
    ],
    [UserType.PropertyManager]: [
        'lease agreements',
        'tenant fit-out approvals',
        'maintenance contracts',
        'inspection reports',
    ],
    [UserType.FacilitiesManager]: [
        'occupancy permits',
        'maintenance manuals',
        'equipment warranties',
        'service reports',
    ],
    [UserType.MaintenanceTechnician]: [
        'maintenance procedures',
        'equipment service manuals',
        'repair records',
        'equipment warranties',
    ],
    [UserType.AssetManager]: [
        'asset registers',
        'capital works plans',
        'condition assessments',
        'asset warranties',
    ],
    [UserType.PortfolioManager]: [
        'building performance reports',
        'property valuations',
        'capital expenditure plans',
        'lease schedules',
    ],
    [UserType.RealEstateDeveloper]: [
        'development approvals',
        'feasibility reports',
        'planning permits',
        'construction contracts',
    ],
    [UserType.BuildingOwner]: [
        'building condition reports',
        'insurance policies',
        'maintenance agreements',
        'occupancy permits',
    ],
    [UserType.LeasingManager]: [
        'lease schedules',
        'tenancy plans',
        'lease agreements',
        'tenant fit-out records',
    ],
    [UserType.OperationsManager]: [
        'operating procedures',
        'service contracts',
        'incident reports',
        'business continuity plans',
    ],
    [UserType.ProjectManager]: [
        'project plans',
        'progress reports',
        'construction specifications',
        'project approvals',
    ],
    [UserType.ComplianceOfficer]: [
        'compliance certificates',
        'occupancy permits',
        'essential safety measures reports',
        'audit reports',
    ],
    [UserType.SafetyManager]: [
        'safety inspection reports',
        'emergency plans',
        'incident records',
        'hazard assessments',
    ],
    [UserType.EnergyManager]: [
        'energy audit reports',
        'utility bills',
        'metering diagrams',
        'energy performance certificates',
    ],
    [UserType.BuildingSuperintendent]: [
        'building operating manuals',
        'service logs',
        'access procedures',
        'emergency contact records',
    ],
    [UserType.RealEstateAnalyst]: [
        'market reports',
        'valuation records',
        'rental schedules',
        'property performance reports',
    ],
    [UserType.SustainabilityManager]: [
        'sustainability reports',
        'environmental assessments',
        'waste management plans',
        'building rating certificates',
    ],
    [UserType.ConstructionManager]: [
        'construction drawings',
        'site inspection reports',
        'construction programmes',
        'quality assurance records',
    ],
    [UserType.BuildingAutomationSpecialist]: [
        'building automation schematics',
        'controls sequences',
        'commissioning reports',
        'controls maintenance records',
    ],
    [UserType.HvacTechnician]: [
        'HVAC service manuals',
        'mechanical drawings',
        'HVAC commissioning reports',
        'air-conditioning maintenance records',
    ],
    [UserType.Consultant]: [
        'consultant reports',
        'building specifications',
        'condition surveys',
        'project briefs',
    ],
    [UserType.Other]: [
        'occupancy permits',
        'building plans',
        'inspection reports',
        'maintenance records',
    ],
    [UserType.StrataManager]: [
        'owners corporation meeting minutes',
        'strata insurance policies',
        'maintenance plans',
        'strata inspection reports',
    ],
    [UserType.BuildingSurveyor]: [
        'building permits',
        'occupancy certificates',
        'building inspection reports',
        'fire engineering reports',
    ],
} as const satisfies Record<UserType, FourStarters>;
